import { Modal, TextField } from '../../components'
import TransactionSummary from '../../UnmatchedPolicy/model/TransactionSummary'

interface Props {
    showErrorPopup: boolean
    handleClose: () => void
    errorMessage: string,
    processDetail?: TransactionSummary
}

const ErrorPopup = (props: Props) => {

    const { showErrorPopup, errorMessage, handleClose } = props;

    return (

        <Modal
            showHeaderCloseButton={false}
            backdrop="static"
            className="create-customer-apply-policy-modal"
            verticallyCentered={true}
            title={props.processDetail?.processStatus == "E" ? "Error" : "Reason"}
            show={showErrorPopup}
            toggle={() => { }}
            body={

                <div>
                    <TextField
                            rows={6}
                            value={errorMessage}
                          />
                </div>
            }
            closeButton={
                {
                    size: "small",
                    icon: "check",
                    iconStyle: { color: "177db8" },
                    outlined: true,
                    color: 'link',
                    onClick(){handleClose()},
                    children: <span style={{ color: "#177db8" }}>Ok</span>

                }
            }
            buttonsAlignment={"right"}
        />

    )
}
export default ErrorPopup
